export default {
  user: {
    profile: 'Profile',
    identification: 'Identification',
    bankCard: 'Bank Card',
    deposit: 'Deposit',
    withdraw: 'Withdraw',
  },
};
